<div class="poll-block show">
    <div class="field-title">
        {{ schema.title? schema.title : 'Заголовок' }}
    </div>
    <div *ngIf="schema.description" class="field-description">
        {{ schema.description }}
    </div>
    <mat-checkbox *ngFor="let option of schema.items.oneOf; let i = index"
    [attr.name]="name"
    value="{{option.d}}"
    (change)="onCheck($event)">
        {{option.d? option.d : 'Вариант ' + i }}
    </mat-checkbox>
</div>